import React from 'react';
import { bool } from 'prop-types';

function AsyncLoading({ error, pastDelay }) {
  if (error) {
    return <div>Error occurs when loading js chunk.</div>;
  }

  if (pastDelay) {
    return '';
  }

  return null;
}

AsyncLoading.propTypes = {
  pastDelay: bool.isRequired,
  error: bool,
};

AsyncLoading.defaultProps = {
  error: '',
};

export default AsyncLoading;



// WEBPACK FOOTER //
// ./app/components/AsyncLoading/AsyncLoading.jsx